// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"wrapper___2I0S3","ad":"ad___1l7me","image":"image___J9xQF"};